"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NoCardSelected = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _svgFetcher = _interopRequireDefault(require("../../utils/svgFetcher"));
var _Icon = require("../../base-components/Icon/Icon");
var _ClickableElement = require("../../base-components/Button/ClickableElement");
var _Sanitizer = require("../../base-components/Sanitizer/Sanitizer");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var NoCardSelected = exports.NoCardSelected = function NoCardSelected(_ref) {
  var addCard = _ref.addCard,
    addCardDtm = _ref.addCardDtm,
    addCardText = _ref.addCardText,
    iconColor = _ref.iconColor,
    namespace = _ref.namespace,
    PlusIcon = _ref.PlusIcon;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "stickyCard no-card-selected"
  }, /*#__PURE__*/_react["default"].createElement(_ClickableElement.ClickableElement, {
    Component: "div",
    className: "add-card",
    onClick: function onClick() {
      return addCard();
    },
    namespacesuffix: "add-icon",
    namespace: namespace,
    dtm: addCardDtm
  }, /*#__PURE__*/_react["default"].createElement(_Icon.Icon, {
    className: "addCardIcon",
    Svg: PlusIcon,
    color: iconColor
  })), /*#__PURE__*/_react["default"].createElement(_Sanitizer.Sanitizer, {
    safelySetInnerHTML: addCardText,
    Component: "p",
    className: "cardText"
  }));
};
NoCardSelected.propTypes = {
  addCard: _propTypes["default"].func.isRequired,
  addCardDtm: _propTypes["default"].objectOf(_propTypes["default"].string),
  addCardText: _propTypes["default"].string,
  iconColor: _propTypes["default"].string.isRequired,
  namespace: _propTypes["default"].string,
  PlusIcon: _propTypes["default"].oneOfType([_propTypes["default"].element, _propTypes["default"].func])
};
NoCardSelected.defaultProps = {
  addCardDtm: {},
  addCardText: 'Click the plus to add another Card to compare',
  namespace: '',
  PlusIcon: function PlusIcon() {
    return (0, _svgFetcher["default"])('axp-icon-plus', 'us-consumer');
  }
};